<template>
  <div class="row">

    <div class="container offset-md-3 col-md-6 pt-5 pb-5">
      <toast ref="toast"></toast>

      <p class="text-right mr-3">
        <a  href="/sign-up"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>新規登録</a>
      </p>
      <form @submit.prevent="login">
        <fieldset id="login_field" class="m-3 card">
          <div class="card-header" style="background-color: #343a40!important;">
              <h3 class="title m-0"></h3>
          </div>
          <div class="card-block p-3">
            <div class="form-group">
              <label for="admin-mail">メールアドレス</label> <span v-if="invalid" class="text-danger">メールアドレスまたはパスワードが間違っています</span>
              <input type="mail" class="form-control" :class="{'border-danger' : invalid}" id="admin-mail" placeholder="メールアドレス" v-model="postData.mail" required>
            </div>
            <div class="form-group">
              <label for="admin-pass">パスワード</label>
              <input type="password" class="form-control" :class="{'border-danger' : invalid}" id="admin-pass" placeholder="パスワードを入力ください" v-model="postData.password" required>
            </div>
            <input type="submit" class="btn btn-primary" value="ログイン" />
          </div>
        </fieldset>
      </form>
      <p class="text-right">
        <a  href="/reset-password"><i class="fa fa-question-circle" aria-hidden="true"></i>パスワードをリセットする</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
.title {
  background: url("../../../img/logo.png") no-repeat left center;
  background-size: contain;
  height: 40px;
  width: 100px;
}
</style>

<script>
import CommonAPI from '../../api/common-api'
import CompanyAPI from '../../api/company-api'
import Toast from '../Toast.vue'

export default {
  name: "sign-up",
 components: {
    Toast
  },
  data() {
    return {
      invalid: false,
      postData: {
        mail: null,
        password: null
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
        this.$root.$refs.loading.$data.show = false
    })
  },
  methods: {
    // ログイン
    login () {
      this.$root.$refs.loading.$data.show = true
      const param = {
            mail: this.postData.mail,
            password: this.postData.password
          }
      CommonAPI.login(param)
            .then(res => {
              localStorage.setItem('x-token', res.token)
              if (res.isAdmin) {
                this.$router.push('/admin/top')
              } else {
                this.$router.push('/operator/top')
              }
            })
            .catch(err => {
              this.$root.$refs.loading.$data.show = false
              // 認証失敗の場合、エラー表示
              if(err.response.status === 401){
                this.invalid = true
                return false
              }
              if(err.response.status === 403){
                this.$refs.toast.showToast(err.response.data.message, 3000, true)
                return false
              }
              console.error(err)
            })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/common/Login.vue